import { api } from '.';
import { loadStripe } from '@stripe/stripe-js';

export const createPayment = async (amount, policy) => {
  const res = await api.post('/payments/create', { amount, policy });

  return res.data.clientSecret;
};

export const initStripe = async () => {
  const res = await api.get('/payments/key');
  const { key } = res.data;

  return loadStripe(key);
};
